import * as CubeTree from '../../../cubeTree/index';
import * as Toolkit from '../../../toolkit/index';
import { __add__, __has__, __updateWrapRect__, __getWrapRect__, __size__ } from './db';

// 新增
export function add(cubeIds: Array<string>): void {
    cubeIds.forEach((cubeId) => {
        if (__has__(cubeId)) {
            return;
        }

        let queryCube: CubeNode = CubeTree.findByCubeId(cubeId);

        if (!queryCube) {
            return;
        }

        __add__(cubeId);
    });
}

export function addWrapRect(rect: LogicCoordinate): void {
    if (__size__() === 0) {
        updateWrapRect(rect);
        return;
    }

    let prevWrap: LogicCoordinate = __getWrapRect__();
    let readyUpdate: Rect = Toolkit.createRectsBorder([
        {
            ...prevWrap
        },
        {
            ...rect
        }
    ]);

    // 拿上一次的外边框，与新增矩形，计算并集外边框，并更新
    updateWrapRect({
        ...readyUpdate
    });
}

export function updateWrapRect(rect: LogicCoordinate): void {
    __updateWrapRect__(rect);
}
